import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { environment } from '../../environments/environment';
import { TokenService } from '../../services/shared/token.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BannerService {
  token: any;

  constructor(private http: HttpClient, private tokenService: TokenService) { }
 
  getBannerData(): Observable<any>{
    return this.http.get(environment.oos.url + '/banner/get-all');
  }

}
